<cx-split-view [hideMode]="false">
  @if (uigStructure$ | async; as uigStructure) {
    @if (listData$ | async; as data) {
      <cx-view class="list">
        <div class="header">
          <div class="title">
            <h3>
              {{
              uigViewType + '.header' | cxTranslate
              }}
              ({{ getListCount(data) }})
            </h3>
          </div>
          <div class="actions">
            @if (data.pagination?.sort) {
              <ng-select
                class="sort type-sort"
                [searchable]="false"
                [clearable]="false"
                (change)="sort(data.pagination)"
                [tabIndex]="0"
                [(ngModel)]="sortCode"
                >
                @for (sort of data.sorts; track sort) {
                  <ng-option [value]="sort.code">
                    {{ uigViewType + '.' + sort.code | cxTranslate }}
                  </ng-option>
                }
              </ng-select>
            }
            <a
              class="btn btn-secondary"
              [routerLink]="{ cxRoute: uigViewType + 'Create' } | cxUrl"
              routerLinkActive="disabled"
              >
              {{ 'branchDetails.buttons.add' | cxTranslate }}
            </a>
          </div>
        </div>
        @if (data.values?.length > 0) {
          <cx-table
            [structure]="uigStructure"
            [data]="data.values"
            [i18nRoot]="domainType"
            [currentItem]="{ property: key, value: currentKey$ | async }"
            (launch)="launchItem($event)"
            [cxFocus]="{ trap: 'both' }"
            >
          </cx-table>
        } @else {
          <p class="instruction is-empty">
            {{ 'branchDetails.messages.emptyList' | cxTranslate }}
          </p>
        }
        <div class="footer">
          <cx-pagination
            [pagination]="data.pagination"
            (viewPageEvent)="browse(data.pagination, $event)"
          ></cx-pagination>
        </div>
      </cx-view>
    }
    <!-- nested split views are rendered inside child routes -->
    <router-outlet></router-outlet>
  }
</cx-split-view>


<ng-template #listHint>
  <p>
    {{ uigViewType + '.hint' | cxTranslate }}
  </p>
</ng-template>
